export const normalizeName=value=>String(value||'').normalize('NFKC').trim().replace(/_/g,' ').replace(/\s+/g,' ').toLocaleLowerCase();
export const nameLines=value=>[...new Map(String(value||'').split(/\r?\n/).map(s=>s.trim()).filter(Boolean).map(s=>[normalizeName(s),s])).values()];
export const termNames=t=>[t.label,t.english,...nameLines(t.aliases),...nameLines(t.redirects)].filter(Boolean);
export function resolveNames(terms,name){const key=normalizeName(name);const byId=terms.filter(t=>!t.deletedAt&&t.id===name);if(byId.length)return byId;return key?terms.filter(t=>!t.deletedAt&&termNames(t).some(n=>normalizeName(n)===key)):[];}
export function prepareNames(before,next,keepOld=true){
 const redirects=nameLines(next.redirects);
 if(before&&normalizeName(before.label)!==normalizeName(next.label)&&keepOld)redirects.push(before.label);
 return {...next,aliases:nameLines(next.aliases).join('\n'),redirects:nameLines(redirects.join('\n')).filter(n=>normalizeName(n)!==normalizeName(next.label)).join('\n')};
}
export function nameConflict(next,terms){
 const others=terms.filter(t=>t.id!==next.id&&!t.deletedAt);
 for(const name of nameLines(next.redirects)){
  if(resolveNames(others,name).length)return '重新導向名稱「'+name+'」已由其他條目使用。';
 }
 for(const other of others)for(const name of nameLines(other.redirects)){
  if(termNames(next).some(n=>normalizeName(n)===normalizeName(name)))return '名稱「'+name+'」已重新導向「'+other.label+'」。';
 }
 return '';
}
